import { offerPlacementSelectionSchema } from "@redotech/redo-integrations-definitions-common/offer-network/offer-placement";
import * as z from "zod";

// null clears the selection (disables the thank-you block).
export const setThankYouOfferPlacement = {
  name: "setThankYouOfferPlacement" as const,
  input: z.object({ selection: offerPlacementSelectionSchema.nullable() }),
  output: z.object({ success: z.boolean() }),
};
